import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { siteInfo } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const links = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !isScrolled
          ? 'bg-transparent'
          : 'bg-white/95 backdrop-blur-sm border-b border-foreground-100/30'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <div className="w-9 h-9 flex items-center justify-center">
            <i className={`ri-book-open-line text-2xl ${isHome && !isScrolled ? 'text-white' : 'text-primary-500'}`}></i>
          </div>
          <span className={`text-lg font-bold whitespace-nowrap ${isHome && !isScrolled ? 'text-white' : 'text-foreground-950'}`}>
            {siteInfo.name}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map((link) => {
            const isActive = link.to === '/' ? location.pathname === '/' : location.pathname.startsWith(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer no-underline ${
                  isActive
                    ? 'bg-primary-500 text-white'
                    : isHome && !isScrolled
                      ? 'text-white/90 hover:text-white hover:bg-white/15'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
            isHome && !isScrolled ? 'text-white' : 'text-foreground-700'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-foreground-100/30 px-4 py-4 flex flex-col gap-2">
          {links.map((link) => {
            const isActive = link.to === '/' ? location.pathname === '/' : location.pathname.startsWith(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer no-underline ${
                  isActive
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
}